import z from 'zod';

export const actorSchema = z.object({
	id: z.string().optional(),
	firstName: z.string().optional(),
	lastName: z.string().optional(),
});

const logTimestampsSchema = z.object({
	createdAt: z.coerce.date().optional(),
	updatedAt: z.coerce.date().optional(),
});

export const accessLogTempAccessRightsSchema = z.object({
	revokeAll: z.boolean().optional(),
	assignRights: z
		.array(
			z.object({
				minutes: z.number(),
				zoneIds: z.array(z.string()),
			}),
		)
		.optional(),
});

export const accessLogDataSchema = z
	.object({
		userIdScanned: z.string().optional(),
		badgeIdScanned: z.string().optional(),
		zoneId: z.string().optional(),
		error: z.string().optional(),
		facePrintRSID: z.unknown().optional(),
		nodeId: z.string().optional(),
		tempAccessRights: accessLogTempAccessRightsSchema.optional(),
	})
	.passthrough();

export const baseLogSchema = z
	.object({
		id: z.string(),
		type: z.string().optional(),
		userId: z.string().optional(),
		eventId: z.string().optional(),
		groupId: z.string().optional(),
		projectId: z.string().optional(),
		fileId: z.string().optional(),
		data: z.unknown().optional(),
		timestamp: z.coerce.date().optional(),
		action: z.string().optional(),
		actor: actorSchema.optional(),
	})
	.merge(logTimestampsSchema);

export const accessLogSchema = baseLogSchema.extend({
	siteId: z.string().optional(),
	zoneId: z.string().optional(),
	deviceId: z.string().optional(),
	status: z.string().optional(),
	direction: z.enum(['in', 'out']).optional(),
	method: z.enum(['device', 'manual', 'automatic']).optional(),
	error: z.string().optional(),
	syncStatus: z.unknown().optional(),
	data: accessLogDataSchema.optional(),
});

export const deviceLogSchema = baseLogSchema.extend({
	deviceId: z.string(),
	event: z.string().optional(),
});

export const userLogSchema = baseLogSchema;
export const groupLogSchema = baseLogSchema;
export const eventLogSchema = baseLogSchema;
export const projectLogSchema = baseLogSchema;

export const systemLogSchema = baseLogSchema.extend({
	url: z.string().optional(),
});

export const notificationLogSchema = baseLogSchema.extend({
	medium: z.enum(['email', 'sms', 'push', 'teams']).optional(),
	subject: z.string().optional(),
	recipients: z.array(z.unknown()).optional(),
	aboutId: z.string().optional(),
	aboutType: z.enum(['event']).optional(),
});

/** API list item shape for mixed log responses. */
export const logSchema = baseLogSchema;

export const logApiResponseSchema = z.object({
	data: z.array(logSchema),
	page: z.number(),
	pageSize: z.number(),
	count: z.number(),
	sort: z.string(),
});
